const STORAGE_KEY = 'duelcash-support-preview';

function getSupportTicket(location) {
  if (!location || location.pathname !== '/support-preview') {
    return null;
  }
  const ticket = new URLSearchParams(location.search || '').get('ticket');
  return ticket && /^[a-f0-9]{64}$/.test(ticket) ? ticket : null;
}

function takeSupportTicket(location, history, bootstrapWindow) {
  let ticket = getSupportTicket(location);
  if (bootstrapWindow) {
    const bootstrapTicket = bootstrapWindow.__duelcashSupportTicket;
    delete bootstrapWindow.__duelcashSupportTicket;
    if (typeof bootstrapTicket === 'string' && /^[a-f0-9]{64}$/.test(bootstrapTicket)) {
      ticket = bootstrapTicket;
    }
  }
  if (location && location.pathname === '/support-preview') {
    history.replaceState(history.state, '', '/support-preview');
  }
  return ticket;
}

function supportPreviewRouteAllowed(pathname) {
  return pathname === '/' || pathname === '/perfil'
    || /^\/game\/[a-z0-9_-]+$/i.test(pathname || '');
}

function shouldTrackCustomerAnalytics(supportPreview) {
  return !supportPreview;
}

function saveSupportSession(storage, session) {
  if (!session || typeof session.token !== 'string' || !Number.isFinite(session.expiresAt)) {
    throw new Error('Invalid support session');
  }
  storage.setItem(STORAGE_KEY, JSON.stringify(session));
}

function readSupportSession(storage, nowSeconds = Math.floor(Date.now() / 1000)) {
  const raw = storage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const session = JSON.parse(raw);
    if (typeof session.token === 'string' && Number.isFinite(session.expiresAt)
        && session.expiresAt > nowSeconds) {
      return { token: session.token, expiresAt: session.expiresAt };
    }
  } catch (error) {
    // Invalid tab state is discarded below.
  }
  storage.removeItem(STORAGE_KEY);
  return null;
}

function clearSupportSession(storage) {
  storage.removeItem(STORAGE_KEY);
}

async function exchangeSupportTicket(fetcher, backendUrl, ticket) {
  if (!/^[a-f0-9]{64}$/.test(ticket || '')) {
    throw new Error('Support preview unavailable');
  }
  const response = await fetcher(backendUrl.replace(/\/$/, '') + '/api/supportPreview', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'exchange', ticket }),
  });
  const result = await response.json();
  if (!response.ok || !result.success || typeof result.supportToken !== 'string'
      || !Number.isFinite(result.expiresAt)) {
    throw new Error('Support preview unavailable');
  }
  return { token: result.supportToken, expiresAt: result.expiresAt };
}

export {
  getSupportTicket,
  takeSupportTicket,
  supportPreviewRouteAllowed,
  shouldTrackCustomerAnalytics,
  saveSupportSession,
  readSupportSession,
  clearSupportSession,
  exchangeSupportTicket,
};
